import { Injectable } from '@angular/core';
import { showHistoryEarnings } from '@box/utils';
import { GlobalStateService } from '@box-core/services/global-state.service';
import { DialogService } from '@box-core/services';
import { UserEventsService } from '@box-core/services/user-events.service';

@Injectable()
export class AccountHistoryService {
  constructor(
    private globalStateService: GlobalStateService,
    private dialogService: DialogService,
    private userEventsService: UserEventsService
  ) {}

  public showEarnings(): boolean {
    const user = this.globalStateService.getUser();
    return showHistoryEarnings(user);
  }

  public showUpdatedHistoryDialog(): void {
    const userEventHistory = this.userEventsService.getUserEventHistory();
    const event = userEventHistory.find((event) => event.key === 'orderHistoryInfoDialog');
    if (!event) {
      this.dialogService.openInfoDialog({
        title: 'updated_history',
        messages: ['by_clicking_on_an_order_you_can_see_all_its_details'],
        btnText: 'ok_'
      });
      this.userEventsService.appendToEventHistory('orderHistoryInfoDialog');
    }
  }
}
